import { BaseService } from './base.service';

export class TrafficService extends BaseService {
    baseUrl = '/traffic';
}
